import { ChevronLeft } from "@mui/icons-material";
import { Button } from "@mui/material";

const BackButton = ({ sx, onClick, disabled = false }) => {
  return (
    <Button
      disabled={disabled}
      onClick={() => {
        onClick && onClick();
        // window.scrollTo(0, 0);
      }}
      variant="outlined"
      startIcon={<ChevronLeft />}
      sx={{ order: { xs: 1, sm: 0 }, ...sx }}
    >
      Back
    </Button>
  );
};

export default BackButton;
